export const paragraphSeparatorRegex = /\p{Zp}/gu;

// charcode
// [8233]
